var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-8 w-8 px-0 py-0 mx-0 rounded-full border-2 border-solid\n                  border-primary-orange text-primary-blue flex items-center justify-center"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }